import { getActivityList, getHomeActivityList } from "@/api/common";
import { Capacitor } from "@capacitor/core";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useActivityStore = defineStore("activityList", () => {
  interface HomeEntity{
    icon : string,
    name:  string
  }
    const activityList = ref([]);
    const homeFloatActivityList = ref<HomeEntity[]>([])
    const getActivities = async (): Promise<void> => {
      try {
         const res = await getActivityList();
          if (res) {
            const resData = res.data
            const isNativeApp = Capacitor.isNativePlatform(); 
            const isStandalone = window.matchMedia('(display-mode: standalone)').matches || navigator.standalone;
            if(isStandalone || isNativeApp){
              activityList.value = resData.filter((item : any) => item.name !== "pwa_reward");
            }else{
              activityList.value = resData
            }
            
            return Promise.resolve();
          } else {
            return Promise.reject();
          }
        } catch (error) {
          console.error("getActivities failed:", error);
        }
    };

    const getFloatIconActivities = async (): Promise<void> => {
      try {
         const res = await getHomeActivityList();
          if (res) {
            const resData = res.data
            homeFloatActivityList.value = resData
            return Promise.resolve();
          } else {
            return Promise.reject();
          }
        } catch (error) {
          console.error("getActivities failed:", error);
        }
    };

    const setActivityList = (data : any) => {
      const stateData = data
       const isNativeApp = Capacitor.isNativePlatform();
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches || navigator.standalone;
      if(isStandalone || isNativeApp){
         activityList.value = stateData.filter((item : any) => item.name !== "pwa_reward");
      }else{
          activityList.value = stateData
      }
    }

    const setFloatIconActivities = (data : any) => {
      homeFloatActivityList.value = data
    }
  return {
    activityList,
    homeFloatActivityList,
    getActivities,
    getFloatIconActivities,
    setActivityList,
    setFloatIconActivities,
  };
}, {
  persist: true,
});
